<ng-container *ngIf="surveydata.length>10 ">
  <div class="w-100 d-flex justify-content-center">
<a class="btn btn-sm btn-outline-primary" (click)="openSurvey()"> Consulter <span class="svg-icon svg-icon-1 m-0" [inlineSVG]="'./assets/images/survey-icon.svg'"></span></a>
  </div>
<lcms-template #modal [modalConfig]="configModal" (cancel)="modal.dismiss()">
<survey [model]="model" ></survey>
</lcms-template>
</ng-container>
<ng-container *ngIf="surveydata.length<=10" ><survey [model]="model" style="margin-bottom: 3px" ></survey></ng-container>
